module.exports = __webpack_public_path__ + "img/airplane_filled.f541067e.svg";